import { useEffect, useState } from "react";
import api from "@/lib/api";

const _cache = {};
const _pending = {};

function fetchRoles(guildId) {
  if (_cache[guildId]) return Promise.resolve(_cache[guildId]);
  if (!_pending[guildId]) {
    _pending[guildId] = api.get(`/guilds/${guildId}/discord/roles`)
      .then((r) => { _cache[guildId] = { linked: !!r.data.linked, roles: r.data.roles || [] }; return _cache[guildId]; })
      .catch(() => { _cache[guildId] = { linked: false, roles: [] }; return _cache[guildId]; });
  }
  return _pending[guildId];
}

// Drop-in role picker. Stores the role NAME (matches how the bot resolves roles),
// so it's compatible with every existing system. Falls back to a text input when
// the bot isn't linked. Skips @everyone in the dropdown.
export function RoleSelect({ guildId, value, onChange, placeholder = "— select a role —", testid, className = "" }) {
  const [data, setData] = useState(_cache[guildId] || null);
  useEffect(() => {
    let alive = true;
    if (guildId) fetchRoles(guildId).then((d) => { if (alive) setData(d); });
    return () => { alive = false; };
  }, [guildId]);

  const base = `bg-black border border-zinc-800 rounded-md px-3 py-2 text-sm outline-none focus:border-volt ${className}`;

  if (!data || !data.linked) {
    return (
      <input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)}
        placeholder={data ? placeholder : "role name"} className={base} />
    );
  }
  const roles = data.roles.filter((r) => r.name !== "@everyone");
  const known = roles.some((r) => r.name === value);
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className={base}>
      <option value="">{placeholder}</option>
      {value && !known && <option value={value}>@{value}</option>}
      {roles.map((r) => <option key={r.id} value={r.name}>@{r.name}</option>)}
    </select>
  );
}

export default RoleSelect;
